var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58621 16 0 12.4138 0 8C0 3.58621 3.58621 0 8 0C12.4138 0 16 3.58621 16 8C16 12.4138 12.4138 16 8 16Z",
    fill: "#E9ECF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29589 8.8296C9.40624 8.55374 9.46141 8.27788 9.46141 8.00202C9.46141 7.11926 8.74417 6.45719 7.83382 6.37443C6.62003 6.26409 5.82003 6.78822 5.489 7.0365C5.35106 7.14684 5.29589 7.36753 5.40624 7.50547C5.51658 7.6434 5.73727 7.67098 5.8752 7.58822C6.17865 7.39512 6.4821 7.33995 6.70279 7.58822C6.92348 7.80891 6.84072 8.13995 6.70279 8.38822L5.35106 11.0641C5.24072 11.3399 5.18555 11.6158 5.18555 11.8917C5.18555 12.7744 5.90279 13.4365 6.81313 13.5193C8.02693 13.6296 8.82693 13.1055 9.15796 12.8572C9.29589 12.7468 9.35106 12.5262 9.24072 12.3882C9.13037 12.2503 8.90968 12.2227 8.77175 12.3055C8.46831 12.4986 8.16486 12.5537 7.94417 12.3055C7.72348 12.0848 7.80624 11.7537 7.94417 11.5055L9.29589 8.8296Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9938 5.51886C9.83175 5.51886 10.511 4.83957 10.511 4.00162C10.511 3.16367 9.83175 2.48438 8.9938 2.48438C8.15585 2.48438 7.47656 3.16367 7.47656 4.00162C7.47656 4.83957 8.15585 5.51886 8.9938 5.51886Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoGray);
export default __webpack_public_path__ + "static/media/icon-info-gray.37a49d9ce028f3ffb35e2b195ab5304c.svg";
export { ForwardRef as ReactComponent };